import { AsyncPipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { EcmRouterModule, LinkService, TrackingData } from '@ecm/router';

import { WhoUsesItViewModel } from '../../../business/model/home/whoUsesIt.view-model';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../services/tracking.service';
import { ParamsUtils } from '../../../utils/params.utils';

@Component({
    selector: 'push-who-uses-it[push]',
    templateUrl: './push-who-uses-it.component.html',
    styleUrls: ['./push-who-uses-it.component.css'],
    standalone: true,
    imports: [AsyncPipe, EcmRouterModule, TranslateModule],
})
export class PushWhoUsesItComponent implements OnInit {
    public trackingName: string;
    public readonly ParamsUtils = ParamsUtils;

    private readonly translate = inject(TranslateService);
    private readonly trackingService = inject(TrackingService);
    private readonly linkService = inject(LinkService);

    @Input()
    public push!: WhoUsesItViewModel;

    @Input()
    public isMobile: boolean;

    @Input()
    public isSoshBrand: boolean;

    public zid!: string;

    public ngOnInit(): void {
        if (this.push) {
            this.zid = this.trackingService.getTrackNamePerType(this.push.type, this.isMobile, this.isSoshBrand);
        }
    }

    public getLink(): void {
        this.translate.get('dashboard.whoUsesIt').subscribe((whoUseContract: any) => {
            this.linkService.openLink(
                whoUseContract['button']['link'],
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.dashboard,
                        trackingArea: 'care_hp_whouseit',
                        trackingName: 'whouseit',
                    },
                }),
                ParamsUtils.cidMap(this.push.cid),
            );
        });
    }
}
